export enum ParametricBoardShutterType {
  Arch = 'arch',
  Basic = 'basic',
  Z = 'z',
}
